import {createContext, PropsWithChildren, useContext} from 'react';
import {AIAgentService, APIService} from '../api';

type GlobalContextType = {
  api: APIService;
  aiAgent: AIAgentService
}

interface GlobalContextProviderProps extends PropsWithChildren {}


export const GlobalContext = createContext<GlobalContextType>({
  api: {} as APIService,
  aiAgent: {} as AIAgentService
});

export const useGlobalContext = () => useContext(GlobalContext);

export const GlobalContextProvider = ({children}: GlobalContextProviderProps) => {
  const api = new APIService();
  const aiAgent = new AIAgentService();

  return (
    <GlobalContext.Provider value={{api, aiAgent}}>
      {children}
    </GlobalContext.Provider>
  );
};